import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import {
  CandidacyScoreChange,
  CreateCandidacyScoreChangeRequest,
  HttpResponse,
} from "@/types";

export function useCreateCandidacyScoreChange() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      createCandidacyScoreChangeRequest,
    }: {
      candidacyId: string;
      createCandidacyScoreChangeRequest: CreateCandidacyScoreChangeRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_score_changes`;
      const res = await httpClient.post<
        CandidacyScoreChange,
        HttpResponse<CandidacyScoreChange>,
        CreateCandidacyScoreChangeRequest
      >(path, createCandidacyScoreChangeRequest);

      return res.data;
    },
  });

  return mutation;
}
